import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    IEmailChannel,
    IInitiateEmail,
    IInitiatedEmail,
} from '@dxp/core/models';
import { environment } from '@dxp/core/environment';
import { LOGGER_REQUEST_NAME } from '@dxp/core/types';

@Injectable({
    providedIn: 'root',
})
export class EmailApiService {
    readonly #http = inject(HttpClient);

    getChannelProviders(): Observable<IEmailChannel[]> {
        return this.#http.get<IEmailChannel[]>(
            `${environment.apiBaseUrl}/channel-providers/graph-email/configurations`,
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Email Service (Get channel providers)',
                ),
            },
        );
    }

    getChannelProvider(id: string): Observable<IEmailChannel> {
        return this.#http.get<IEmailChannel>(
            `${environment.apiBaseUrl}/channel-providers/graph-email/configurations/${id}`,
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Email Service (Get channel provider)',
                ),
            },
        );
    }

    initiate(request: IInitiateEmail): Observable<IInitiatedEmail> {
        return this.#http.post<IInitiatedEmail>(
            `${environment.apiBaseUrl}/email/initiate`,
            request,
            {
                context: new HttpContext().set(
                    LOGGER_REQUEST_NAME,
                    'Email Service (Initiate email)',
                ),
            },
        );
    }
}
